import type {ItemsListSorting} from '../modules/public/ads/AdsModuleTypes'

// Опции сортировки объявлений.
export const ItemsListSortingOptions: ItemsListSorting[] = [
    'default',
    'price_asc',
    'price_desc',
    'newest',
    'discount_amount',
]
